/**
 * Footer alignment resolution, shared by `FooterRenderer` and `FooterEditor` so the pill the
 * editor highlights always matches the layout the canvas draws for the same stored value.
 */

import { DEFAULT_FOOTER_ALIGNMENT, FOOTER_ALIGNMENT_VALUES, type FooterAlignment } from "./constants";

/**
 * Resolves a stored footer `alignment` to a known value.
 *
 * Anything that isn't one of {@link FOOTER_ALIGNMENT_VALUES} (missing on footers saved before
 * alignment existed, `null` after a copilot clear, or a malformed direct save) falls back to the
 * default split layout. A membership check rather than a keyed lookup, so a value like
 * `"constructor"` can't resolve to an `Object.prototype` member.
 * @param value - The footer's stored alignment; may be missing or invalid.
 * @returns The alignment to render and to show as selected.
 */
export function resolveFooterAlignment(value: unknown): FooterAlignment {
  return FOOTER_ALIGNMENT_VALUES.find((alignment) => alignment === value) ?? DEFAULT_FOOTER_ALIGNMENT;
}
